import { Button, Menu, MenuItem, styled } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { copyUserLink, copyNicheLink } from "utils/share";
import { isAuthenticated } from "services/Auth";
import { routes } from "routes";
import colors from "../../theme/themeConstants";
import classes from "./Styles.module.css";
import { ReactComponent as EditIcon } from "../../components/icons/edit_icon.svg";
import { ReactComponent as ShareIcon } from "../../components/icons/share_icon_red.svg";
import { ReactComponent as ManageIcon } from "../../components/icons/manage_icon.svg";
import useWindowDimensions from "../../hooks/useWindowDimension";

interface IProps {
  tooglePopup: () => void;
  userName?: string;
  myself?: boolean;
  nicheName?: string;
}

const ProfileDropdownMenu = (props: IProps) => {
  const { tooglePopup, userName, myself, nicheName } = props;
  const navigate = useNavigate();
  const [isAuth, setIsAuth] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const isAllowManage = myself && isAuth;

  const isDesktop = useWindowDimensions();

  useEffect(() => {
    (async () => {
      setIsAuth(await isAuthenticated());
    })();
  });

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isDesktop) {
      setAnchorEl(event.currentTarget);
    } else {
      tooglePopup();
    }
  };

  const handleStopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const handleClose = (event: React.MouseEvent) => {
    handleStopPropagation(event);
    setAnchorEl(null);
  };

  const handleCopy = async () => {
    if (nicheName) {
      await copyNicheLink(nicheName);
    }

    if (userName) {
      await copyUserLink(userName);
    }
  };

  const handleManage = () => {
    navigate(routes.manageProfile());
  };

  const handleEdit = () => {
    navigate(routes.accountSettings());
  };

  const ACTIONS = [
    ...(isAllowManage ? [{ text: "Edit", icon: EditIcon, onClick: handleEdit }] : []),
    { text: "Share", icon: ShareIcon, onClick: handleCopy },
    ...(isAllowManage ? [{ text: "Manage", icon: ManageIcon, onClick: handleManage }] : [])
  ];

  return (
    <Container>
      <Button
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          marginLeft: "100%",
          minWidth: "2rem",
          minHeight: "2rem",
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          position: "absolute",
          right: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          backgroundColor: colors.lightGray_GoBackButton,
          "&:hover": {
            backgroundColor: colors.lightGrayHover
          },
          ".circle": {
            width: 4,
            opacity: 0.4,
            height: 4,
            borderRadius: "50%",
            border: "1.5px solid #fff",
            "&:nth-of-type(2),&:nth-of-type(3)": {
              marginTop: "3px"
            }
          }
        }}
      >
        <span className="circle"></span>
        <span className="circle"></span>
        <span className="circle"></span>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        classes={{ paper: classes.menuList }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {ACTIONS.map(({ onClick, text, icon: Icon }, index) => (
          <div key={index}>
            <MenuItem
              onClick={onClick}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: 12,
                fontWeight: 500,
                fontFamily: "Poppins",
                lineHeight: "18px",
                padding: "6px 10px",
                margin: "0 6px",
                borderRadius: "6px"
              }}
            >
              <Icon />
              <ShareButtonLabel>{text}</ShareButtonLabel>
            </MenuItem>
          </div>
        ))}
      </Menu>
    </Container>
  );
};

const ShareButtonLabel = styled("p")({
  fontSize: "12px",
  fontFamily: "Poppins",
  fontWeight: 500,
});

const Container = styled("div")({});

export default ProfileDropdownMenu;
